import React from "react";
import { CircularProgress } from "@material-ui/core";
import { green } from "@material-ui/core/colors";

const ProgressIndicator = () => {
  return <CircularProgress style={{ color: green[500] }} thickness={7} />;
};

export default ProgressIndicator;
